import axios from 'axios';

class FormulasDataService {

  search(data) {
    return axios.post(`/api/formulas/search`, data);
  }
  // 

  sugeridas(id) {
    return axios.get(`/api/formulas/sugerencia/${id}`);
  }

  getAll() {
    return axios.get(`/api/formulas`);
  }

  getPage(p) {
    return axios.get(`/api/formulas`, { params: p });
  }

  get(id) {
    return axios.get(`/api/formulas/${id}`);
  }

  create(data) {
    return axios.post(`/api/formulas`, data);
  }

  update(id, data) {
    return axios.put(`/api/formulas/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/api/formulas/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/formulas`);
  }
}

export default new FormulasDataService();